export interface EmojiEntry {
  char: string;
  group: string;
  keywords: ReadonlyArray<string>;
}

export const EMOJI_CATALOG: ReadonlyArray<EmojiEntry> = [
  { char: '🍜', group: 'food', keywords: ['拉麵', '麵食', 'ramen', 'noodle'] },
  { char: '🍚', group: 'food', keywords: ['白飯', '飯', 'rice'] },
  { char: '🍙', group: 'food', keywords: ['飯糰', 'onigiri'] },
  { char: '🍣', group: 'food', keywords: ['壽司', 'sushi'] },
  { char: '🍱', group: 'food', keywords: ['便當', 'bento', 'lunch'] },
  { char: '🍛', group: 'food', keywords: ['咖哩', 'curry'] },
  { char: '🍲', group: 'food', keywords: ['火鍋', '湯', 'hotpot', 'stew'] },
  { char: '🍔', group: 'food', keywords: ['漢堡', 'burger'] },
  { char: '🍕', group: 'food', keywords: ['披薩', 'pizza'] },
  { char: '🌭', group: 'food', keywords: ['熱狗', 'hotdog'] },
  { char: '🌮', group: 'food', keywords: ['塔可', 'taco'] },
  { char: '🥗', group: 'food', keywords: ['沙拉', 'salad'] },
  { char: '🥪', group: 'food', keywords: ['三明治', 'sandwich'] },
  { char: '🍞', group: 'food', keywords: ['麵包', 'bread'] },
  { char: '🥐', group: 'food', keywords: ['可頌', 'croissant'] },
  { char: '🥯', group: 'food', keywords: ['貝果', 'bagel'] },
  { char: '🥟', group: 'food', keywords: ['餃子', '水餃', 'dumpling'] },
  { char: '🍤', group: 'food', keywords: ['炸蝦', 'shrimp', 'tempura'] },
  { char: '🍖', group: 'food', keywords: ['肉', 'meat'] },
  { char: '🍗', group: 'food', keywords: ['雞腿', 'chicken'] },
  { char: '🥩', group: 'food', keywords: ['牛排', 'steak'] },
  { char: '🥞', group: 'food', keywords: ['鬆餅', '早午餐', 'pancake', 'brunch'] },
  { char: '🍩', group: 'food', keywords: ['甜甜圈', 'donut'] },
  { char: '🍰', group: 'food', keywords: ['蛋糕', 'cake'] },
  { char: '🧁', group: 'food', keywords: ['杯子蛋糕', 'cupcake'] },
  { char: '🍪', group: 'food', keywords: ['餅乾', 'cookie'] },
  { char: '🍫', group: 'food', keywords: ['巧克力', 'chocolate'] },
  { char: '🍦', group: 'food', keywords: ['冰淇淋', 'ice cream'] },
  { char: '🍧', group: 'food', keywords: ['剉冰', '刨冰', 'shaved ice'] },
  { char: '☕', group: 'food', keywords: ['咖啡', 'coffee'] },
  { char: '🧋', group: 'food', keywords: ['珍奶', '手搖', 'boba', 'milk tea'] },
  { char: '🍵', group: 'food', keywords: ['茶', '抹茶', 'tea', 'matcha'] },
  { char: '🥤', group: 'food', keywords: ['飲料', 'drink', 'soda'] },
  { char: '🍺', group: 'food', keywords: ['啤酒', 'beer'] },
  { char: '🍷', group: 'food', keywords: ['紅酒', 'wine'] },
  { char: '🥃', group: 'food', keywords: ['烈酒', 'whisky'] },
  { char: '🍎', group: 'food', keywords: ['蘋果', 'apple', 'fruit'] },
  { char: '🍌', group: 'food', keywords: ['香蕉', 'banana'] },
  { char: '🍓', group: 'food', keywords: ['草莓', 'strawberry'] },
  { char: '🍇', group: 'food', keywords: ['葡萄', 'grape'] },

  { char: '🚗', group: 'transport', keywords: ['汽車', '計程車', 'car', 'taxi'] },
  { char: '🚕', group: 'transport', keywords: ['計程車', 'taxi'] },
  { char: '🚙', group: 'transport', keywords: ['休旅車', 'suv'] },
  { char: '🚌', group: 'transport', keywords: ['公車', '巴士', 'bus'] },
  { char: '🚎', group: 'transport', keywords: ['電車', 'trolley'] },
  { char: '🏍️', group: 'transport', keywords: ['機車', '摩托車', 'motorcycle'] },
  { char: '🛵', group: 'transport', keywords: ['速克達', 'scooter'] },
  { char: '🚲', group: 'transport', keywords: ['腳踏車', 'bike'] },
  { char: '🛴', group: 'transport', keywords: ['滑板車', 'scooter'] },
  { char: '🚄', group: 'transport', keywords: ['高鐵', '高速鐵路', 'high-speed rail'] },
  { char: '🚆', group: 'transport', keywords: ['火車', 'train'] },
  { char: '🚇', group: 'transport', keywords: ['捷運', '地鐵', 'metro', 'subway'] },
  { char: '✈️', group: 'transport', keywords: ['飛機', 'plane'] },
  { char: '🚢', group: 'transport', keywords: ['船', '郵輪', 'ship', 'cruise'] },
  { char: '⛽', group: 'transport', keywords: ['加油', '油費', 'fuel', 'gas'] },
  { char: '🅿️', group: 'transport', keywords: ['停車', 'parking'] },

  { char: '🏠', group: 'home', keywords: ['家', '房子', 'home', 'house'] },
  { char: '🏡', group: 'home', keywords: ['住宅', '別墅', 'house', 'home'] },
  { char: '🏢', group: 'home', keywords: ['辦公室', '大樓', 'office', 'building'] },
  { char: '🛏️', group: 'home', keywords: ['床', '臥室', 'bed', 'bedroom'] },
  { char: '🛋️', group: 'home', keywords: ['沙發', '客廳', 'sofa', 'living room'] },
  { char: '🚿', group: 'home', keywords: ['洗澡', '水費', 'shower', 'water'] },
  { char: '🛁', group: 'home', keywords: ['浴缸', '泡澡', 'bath', 'bathtub'] },
  { char: '🚽', group: 'home', keywords: ['馬桶', '衛浴', 'toilet'] },
  { char: '💡', group: 'home', keywords: ['燈泡', '電費', 'light', 'bulb'] },
  { char: '🔌', group: 'home', keywords: ['插座', '電器', 'plug'] },
  { char: '🔥', group: 'home', keywords: ['火', '瓦斯', 'fire', 'gas'] },
  { char: '💧', group: 'home', keywords: ['水滴', '水費', 'water', 'droplet'] },
  { char: '🧹', group: 'home', keywords: ['打掃', '掃把', 'broom', 'cleaning'] },
  { char: '🧺', group: 'home', keywords: ['洗衣籃', 'laundry'] },
  { char: '🧻', group: 'home', keywords: ['衛生紙', '日用品', 'toilet paper'] },
  { char: '🧼', group: 'home', keywords: ['肥皂', '清潔', 'soap'] },

  { char: '🎮', group: 'activity', keywords: ['電玩', '遊戲', 'gaming', 'game'] },
  { char: '🎯', group: 'activity', keywords: ['目標', '飛鏢', 'target', 'darts'] },
  { char: '🎲', group: 'activity', keywords: ['骰子', '桌遊', 'dice', 'board game'] },
  { char: '🎬', group: 'activity', keywords: ['電影', '看片', 'movie', 'cinema'] },
  { char: '🎵', group: 'activity', keywords: ['音樂', '音符', 'music', 'note'] },
  { char: '🎤', group: 'activity', keywords: ['麥克風', '唱歌', 'mic', 'karaoke'] },
  { char: '🎧', group: 'activity', keywords: ['耳機', '聽音樂', 'headphones'] },
  { char: '🎸', group: 'activity', keywords: ['吉他', '樂器', 'guitar'] },
  { char: '🎨', group: 'activity', keywords: ['畫畫', '藝術', 'art', 'painting'] },
  { char: '📷', group: 'activity', keywords: ['相機', '攝影', 'camera', 'photography'] },
  { char: '⚽', group: 'activity', keywords: ['足球', 'soccer', 'football'] },
  { char: '🏀', group: 'activity', keywords: ['籃球', 'basketball'] },
  { char: '🎾', group: 'activity', keywords: ['網球', 'tennis'] },
  { char: '🏃', group: 'activity', keywords: ['跑步', '運動', 'running', 'exercise'] },
  { char: '🧘', group: 'activity', keywords: ['瑜伽', '冥想', 'yoga', 'meditation'] },
  { char: '🏋️', group: 'activity', keywords: ['健身', '舉重', 'gym', 'workout'] },
  { char: '🏊', group: 'activity', keywords: ['游泳', 'swimming'] },
  { char: '🚴', group: 'activity', keywords: ['騎車', '單車', 'cycling'] },

  { char: '🌴', group: 'travel', keywords: ['度假', '海島', 'vacation', 'tropical'] },
  { char: '⛱️', group: 'travel', keywords: ['海邊', '沙灘傘', 'beach', 'umbrella'] },
  { char: '🏖️', group: 'travel', keywords: ['沙灘', 'beach'] },
  { char: '🏔️', group: 'travel', keywords: ['雪山', '高山', 'mountain', 'snow'] },
  { char: '⛰️', group: 'travel', keywords: ['登山', 'mountain', 'hiking'] },
  { char: '🗺️', group: 'travel', keywords: ['地圖', 'map'] },
  { char: '🧳', group: 'travel', keywords: ['行李箱', 'luggage'] },
  { char: '🏨', group: 'travel', keywords: ['飯店', '住宿', 'hotel', 'lodging'] },
  { char: '⛺', group: 'travel', keywords: ['露營', '帳篷', 'camping', 'tent'] },
  { char: '🗽', group: 'travel', keywords: ['出國', '紐約', 'travel', 'liberty'] },
  { char: '🗼', group: 'travel', keywords: ['東京塔', '日本', 'tokyo', 'japan'] },
  { char: '🎡', group: 'travel', keywords: ['摩天輪', '遊樂園', 'ferris wheel'] },
  { char: '🎢', group: 'travel', keywords: ['雲霄飛車', '遊樂園', 'roller coaster'] },

  { char: '💳', group: 'object', keywords: ['信用卡', 'credit card'] },
  { char: '💵', group: 'object', keywords: ['美金', '鈔票', 'cash', 'dollar'] },
  { char: '💴', group: 'object', keywords: ['日幣', '鈔票', 'yen'] },
  { char: '💶', group: 'object', keywords: ['歐元', 'euro'] },
  { char: '💷', group: 'object', keywords: ['英鎊', 'pound'] },
  { char: '💰', group: 'object', keywords: ['錢袋', '財富', 'money bag', 'wealth'] },
  { char: '💸', group: 'object', keywords: ['花錢', '飛錢', 'money flying'] },
  { char: '🪙', group: 'object', keywords: ['硬幣', '銅板', 'coin'] },
  { char: '🧾', group: 'object', keywords: ['收據', '發票', 'receipt'] },
  { char: '🏦', group: 'object', keywords: ['銀行', 'bank'] },
  { char: '🏧', group: 'object', keywords: ['提款機', 'atm'] },
  { char: '📱', group: 'object', keywords: ['手機', '電信', 'mobile', 'phone'] },
  { char: '💻', group: 'object', keywords: ['筆電', 'laptop'] },
  { char: '🖥️', group: 'object', keywords: ['桌機', 'desktop'] },
  { char: '⌚', group: 'object', keywords: ['手錶', 'watch'] },
  { char: '👕', group: 'object', keywords: ['T恤', '衣服', 't-shirt', 'clothing'] },
  { char: '👗', group: 'object', keywords: ['洋裝', 'dress'] },
  { char: '👖', group: 'object', keywords: ['牛仔褲', 'jeans'] },
  { char: '👟', group: 'object', keywords: ['運動鞋', 'sneakers'] },
  { char: '👜', group: 'object', keywords: ['包包', 'handbag'] },
  { char: '👓', group: 'object', keywords: ['眼鏡', 'glasses'] },
  { char: '💄', group: 'object', keywords: ['口紅', '化妝', 'lipstick', 'makeup'] },
  { char: '💍', group: 'object', keywords: ['戒指', '珠寶', 'ring', 'jewelry'] },
  { char: '📚', group: 'object', keywords: ['書本', '閱讀', 'books', 'reading'] },
  { char: '📖', group: 'object', keywords: ['書', '學習', 'book', 'study'] },
  { char: '✏️', group: 'object', keywords: ['鉛筆', '文具', 'pencil'] },
  { char: '🎁', group: 'object', keywords: ['禮物', 'gift'] },
  { char: '🛒', group: 'object', keywords: ['購物', '採買', 'shopping', 'cart'] },
  { char: '🛍️', group: 'object', keywords: ['購物袋', 'shopping bag'] },

  { char: '❤️', group: 'symbol', keywords: ['愛心', '愛', 'heart', 'love'] },
  { char: '💖', group: 'symbol', keywords: ['粉紅愛心', 'sparkling heart'] },
  { char: '⭐', group: 'symbol', keywords: ['星星', '收藏', 'star'] },
  { char: '✨', group: 'symbol', keywords: ['閃亮', '美妝', 'sparkles'] },
  { char: '🔔', group: 'symbol', keywords: ['鈴鐺', '通知', 'bell'] },
  { char: '🎉', group: 'symbol', keywords: ['慶祝', '派對', 'celebration', 'party'] },
  { char: '🎊', group: 'symbol', keywords: ['彩球', 'confetti'] },
  { char: '🎀', group: 'symbol', keywords: ['蝴蝶結', 'ribbon'] },
  { char: '🏷️', group: 'symbol', keywords: ['標籤', 'tag', 'label'] },
  { char: '⏰', group: 'symbol', keywords: ['鬧鐘', '時間', 'alarm', 'clock'] },
  { char: '📅', group: 'symbol', keywords: ['行事曆', '日期', 'calendar'] },
  { char: '🔒', group: 'symbol', keywords: ['鎖', '安全', 'lock'] },
  { char: '🔑', group: 'symbol', keywords: ['鑰匙', 'key'] },
  { char: '⚙️', group: 'symbol', keywords: ['設定', '齒輪', 'settings', 'gear'] },
  { char: '☁️', group: 'symbol', keywords: ['雲', '雲端', 'cloud'] },
  { char: '🌞', group: 'symbol', keywords: ['太陽', '晴天', 'sun', 'sunny'] },
  { char: '🌙', group: 'symbol', keywords: ['月亮', '夜晚', 'moon', 'night'] },

  { char: '🐶', group: 'animal', keywords: ['狗', 'dog'] },
  { char: '🐱', group: 'animal', keywords: ['貓', 'cat'] },
  { char: '🐰', group: 'animal', keywords: ['兔子', 'rabbit'] },
  { char: '🐹', group: 'animal', keywords: ['倉鼠', 'hamster'] },
  { char: '🐦', group: 'animal', keywords: ['鳥', 'bird'] },
  { char: '🐢', group: 'animal', keywords: ['烏龜', 'turtle'] },
  { char: '🐠', group: 'animal', keywords: ['熱帶魚', '魚', 'fish'] },
  { char: '🦴', group: 'animal', keywords: ['骨頭', '寵物零食', 'bone'] },
  { char: '🐾', group: 'animal', keywords: ['腳印', '寵物', 'paw'] },
  { char: '🐮', group: 'animal', keywords: ['牛', 'cow'] },
  { char: '🐷', group: 'animal', keywords: ['豬', 'pig'] },

  { char: '💊', group: 'misc', keywords: ['藥', '藥品', 'pill', 'medicine'] },
  { char: '💉', group: 'misc', keywords: ['打針', '疫苗', 'syringe', 'vaccine'] },
  { char: '🩺', group: 'misc', keywords: ['聽診器', '看診', 'stethoscope'] },
  { char: '🩹', group: 'misc', keywords: ['ok繃', 'bandage'] },
  { char: '🏥', group: 'misc', keywords: ['醫院', 'hospital'] },
  { char: '🦷', group: 'misc', keywords: ['牙齒', '牙科', 'tooth', 'dental'] },
  { char: '🧠', group: 'misc', keywords: ['大腦', 'brain'] },
  { char: '🌱', group: 'misc', keywords: ['植物', '園藝', 'plant', 'gardening'] },
  { char: '🌳', group: 'misc', keywords: ['樹', 'tree'] },
  { char: '🌸', group: 'misc', keywords: ['花', '春天', 'flower', 'cherry blossom'] },
  { char: '💐', group: 'misc', keywords: ['花束', '送禮', 'bouquet'] },
  { char: '🎓', group: 'misc', keywords: ['畢業', '學費', 'graduation'] },
  { char: '💼', group: 'misc', keywords: ['公事包', '工作', 'briefcase', 'work'] },
  { char: '🧧', group: 'misc', keywords: ['紅包', '禮金', 'red envelope'] },
  { char: '🪪', group: 'misc', keywords: ['身分證', 'id card'] },
];
